import { useEffect, useState } from "react";
import { authService } from "../service";

export const useGetMe = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUser = async () => {
    try {
      setLoading(true);
      const res = await authService.getMe();
      setUser(res.data);
      setError(null);
    } catch (err) {
      console.error("Erreur de récupération de l'utilisateur :", err.message);
      setError(err);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;
    fetchUser();
  }, []);

  return { user, loading, error, refreshUser: fetchUser };
};
